/**
 * PeopleAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PeopleAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12.248 13.006A5 5 0 0 1 17 18v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.703-2.985L12 15H7a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 5-5h5zM18 13a4 4 0 0 1 4 4v3a1 1 0 1 1-2 0v-3a2 2 0 0 0-2-2 1 1 0 1 1 0-2" />
    <path
      fillRule="evenodd"
      d="M9.442 3.001a4.17 4.17 0 0 1 4.2 4.1v.022a4.34 4.34 0 0 1-3.97 4.293l-.207.013h-.073A4.337 4.337 0 0 1 5.22 7.332l-.006-.209v-.021A4.17 4.17 0 0 1 9.414 3h.029zM9.2 5.008a2.17 2.17 0 0 0-1.985 2.114 2.334 2.334 0 0 0 2.213 2.304 2.34 2.34 0 0 0 1.556-.704c.417-.43.652-1.002.659-1.6a2.166 2.166 0 0 0-1.985-2.114L9.443 5h-.03z"
      clipRule="evenodd"
    />
    <path d="M15.405 3.003a4.167 4.167 0 0 1 4.023 4.099v.021a4.337 4.337 0 0 1-4.178 4.306 1.001 1.001 0 0 1-.072-2 2.337 2.337 0 0 0 2.249-2.315 2.166 2.166 0 0 0-1.984-2.106L15.23 5l-.102-.003A1.001 1.001 0 0 1 15.199 3z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PeopleAltIcon = makeIcon('PeopleAltIcon', PeopleAltIconSvg)
